import {getCartBillingAddress, getCartContactPerson, getCartContractPartner, getCartNote, getCartPaymentSettings, getCartRecommendedAccount, getCartVerification} from "./SimpleSelectors";
import {createSelector} from "reselect";
import countries from 'i18n-iso-countries'


// **************************************************************************************************************
export const getSepaForm = (state) => state.form.sepaPayment
export const getAlternateSepaForm = (state) => state.form.alternateSepaPayment
export const getContractPartnerForm = (state) => state.form.contractPartner
export const getContactPersonForm = (state) => state.form.contactPerson
export const getBillingAddressForm = (state) => state.form.billingAddress
export const getPhoneVerificationForm = (state) => state.form.phoneVerification
export const getPromotionCodeForm = (state) => state.form.promotionCodeForm
export const getCommissionForm = (state) => state.form.commissionForm
export const getOrderNoteForm = (state) => state.form.existingUserNote
export const getSimpleSummaryForm = (state) => state.form.summary
export const getLoginForm = (state) => state.form.loginForm
export const getTestingForm = (state) => state.form.testing;
export const getProjectSelectionForm = (state) => state && state.form.projectSelection;
export const getRecommendForm = (state) => state && state.form.recommend;

export const isNewCustomerSelected = (state) => state.clientDataStep.newCustomerSelected
export const isUserAuthenticated = (state) => state.clientDataStep.existingUserAuthenticated


export const getFormLabels = (labelSetId = false) => {

    let labels = {}

    switch (labelSetId) {

        case "login":
            labels.username = "Kundennummer"
            labels.password = "Passwort"
            labels.totp = "Zwei-Faktor-Authentifizierungscode"
            labels.devicecookie = "Verifizierungscode"
            break

        default:
            labels.note = "Notiz"
            labels.salutation = "Anrede"
            labels.company = "Firma"
            labels.vat = "USt-IdNr."
            labels.firstName = "Vorname"
            labels.lastName = "Nachname"
            labels.emailAddress = "E-Mail-Adresse"
            labels.phone = "Telefonnummer"
            labels.street = "Straße"
            labels.houseNumber = "Hausnummer"
            labels.zip = "PLZ"
            labels.city = "Ort"
            labels.country = "Land"
            labels.recommendedAccount = "Kundentyp"
            labels.title = "Titel"
            labels.commission = 'Betreuer-ID'
            break

    }

    return labels

}

// **************************************************************************************************************
const countryData = countries.getNames("de")

/*const isSMSValidationSuccess = (state) => {
	return state.smsVerification.codeSuccessfullyVerified
}*/

export const getInitialSepaData = createSelector(
    [getCartPaymentSettings],
    (paymentSettings) => {
        if (!paymentSettings) {
            return {}
        }
        return {
            accountHolder: paymentSettings.accountHolder,
            bic: paymentSettings.bic,
            iban: paymentSettings.iban
        }
    }
)

export const getInitialBillingAddress = createSelector(
    [getCartBillingAddress],
    (billingAddress) => {
        const defaultAddress = {}
        if (billingAddress && billingAddress.salutation === '') {
            billingAddress.salutation = 'keine Angabe'
        }
        return Object.assign({}, defaultAddress, billingAddress)
    }
)

export const getInitialContactPerson = createSelector(
    [getCartContactPerson],
    (contactPerson) => {
        const defaultAddress = {}
        if (contactPerson && contactPerson.salutation === '') {
            contactPerson.salutation = 'keine Angabe'
        }
        return Object.assign({}, defaultAddress, contactPerson)
    }
)

export const getInitialContractPartner = createSelector(
    [getCartContractPartner, getCartRecommendedAccount, getCartNote],
    (contractPartner, recommendedAccount, orderNote) => {
        let extendedFormData = {}
        if (orderNote) {
            extendedFormData["note"] = orderNote
        }
        if (recommendedAccount) {
            extendedFormData["recommendedAccount"] = recommendedAccount
        }
        if (contractPartner && contractPartner.salutation === '') {
            contractPartner.salutation = 'keine Angabe'
        }
        return Object.assign({}, extendedFormData, contractPartner)
    }
)

//todo: return existing customer data if available and selected
// returns actual billing address
export const getActualBillingAddress = createSelector(
    [getCartContractPartner, getCartBillingAddress],
    (contractPartner, billingAddress) => {
        if (billingAddress) {
            return billingAddress
        } else {
            return contractPartner
        }
    }
)

// returns blling address data
export const getActualBillingAddressSmall = createSelector(
    [getActualBillingAddress],
    (actualAddress) => {
        if (!actualAddress) {
            return []
        }
        let smallAddressData = [
            actualAddress.company ? actualAddress.company : (actualAddress.firstName + " " + actualAddress.lastName),
            actualAddress.street + " " + actualAddress.houseNumber,
            actualAddress.zip + " " + actualAddress.city,
            countryData[actualAddress.country]
        ]
        return smallAddressData
    }
)

//todo: return existing customer data if available and selected
// returns blling address data
export const getContractPartnerAddressSmall = createSelector(
    [getCartContractPartner],
    (contractPartner) => {
        if (!contractPartner) {
            return []
        }
        let smallAddressData = [
            contractPartner.street + " " + contractPartner.houseNumber,
            contractPartner.zip + " " + contractPartner.city,
            countryData[contractPartner.country]
        ]
        return smallAddressData
    }
)

// returns billing email address
export const getActualEmailAddress = createSelector(
    [getActualBillingAddress],
    (actualAddress) => {
        if (!actualAddress) {
            return ""
        }
        return actualAddress.emailAddress
    }
)


export const getPhoneVerification = createSelector(
    [getCartVerification],
    (verification) => {

        if (!verification) {
            return false
        }

        return verification

    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/Forms.js
 **/